<ion-list>
    @if(modalOption.option) {
  <ion-item class="ion-no-padding" lines='none'> 
      <ion-label class="cursor-pointer" (click)="modalOption.option.action(); dismiss()">
          <a class="link-black">{{modalOption.option.label}}</a>
      </ion-label>
  </ion-item>
}
  @if(modalOption.option2) {
  <ion-item class="ion-no-padding" lines='none'> 
    <ion-label class="cursor-pointer" (click)="modalOption.option2.action(); dismiss()">
        <a class="link-black">{{modalOption.option2.label}}</a>
    </ion-label>
</ion-item>
}
</ion-list>